import { F01_IMAGES } from 'data/images/f01/default'
import { isEnergyPitchFunnelSpecificVariant } from 'data/images/utils'
import type { ImagesDefinition } from 'types/images'

export const WALLPIF01_IMAGES = {
  ...F01_IMAGES,
  experience: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/wallpif01/memoji/experience.webp',
        '/images/wallpif01/memoji/experience@2x.webp',
      ],
    },
  },
  experiencePitch: {
    pitch: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/wallpif01/memoji/experience_pitch.webp',
        '/images/wallpif01/memoji/experience_pitch@2x.webp',
      ],
    },
  },
  energyPitch: {
    ...F01_IMAGES.energyPitch,
    person: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/wallpif01/memoji/energy-pitch/person.webp',
        '/images/wallpif01/memoji/energy-pitch/person@2x.webp',
      ],
      prefetchCondition: isEnergyPitchFunnelSpecificVariant,
    },
  },
} satisfies ImagesDefinition
